import CollaborativeView from "@features/tools/view/collaborative-view";

const Collaborative = () => {
  return <CollaborativeView />;
};

export default Collaborative;
